// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"0fa0bd29","116":"0fa0bd29","441":"335c7a45","712":"a922a328"}[chunkId] + ".chunk.css";
};